import React from 'react';
import { MEDIA_FRAME_PRESETS, mediaFrameOptions } from '../config/presentationPresets';
import './MediaFrame.css';

export const MEDIA_FRAME_OPTIONS = mediaFrameOptions();

export default function MediaFrame({ type = 'none', children, className = '' }) {
  const preset = MEDIA_FRAME_PRESETS[type];
  if (!preset) return children;
  const style = {
    '--media-frame-image': `url('${preset.url}')`,
    '--media-frame-slice': preset.slice,
    '--media-frame-width': `${preset.width}px`,
    '--media-frame-inset': `${preset.inset}px`,
    '--media-frame-radius': `${preset.radius}px`,
  };
  return <div className={`set-media-frame set-media-frame-${type} ${className}`} style={style}><div className="set-media-frame-content">{children}</div></div>;
}
